module.exports = __webpack_public_path__ + "img/dropsBanner_320.1177c913.png";